import {IComponentController, ILocationService, IScope} from "angular";
import {Opportunity} from "../../model/Opportunity";

export interface AbstractNotificationComponentScope extends IScope {
    notification: Opportunity;
}

export class AbstractNotificationComponent implements IComponentController {

    public $location: ILocationService;
    public $scope: AbstractNotificationComponentScope;
    public notification: Opportunity;
    
    constructor($scope: AbstractNotificationComponentScope,
                $location: ILocationService) {
        this.$location = $location;
        this.$scope = $scope;
    }

    public $onInit = () => {
        this.$scope.notification = this.notification;
    };

}